import { css } from '@linaria/core';

export const screenContainer = css`
  --screen-padding: 16px;
  --screen-max-width: 1024px;
  max-width: min(var(--screen-max-width), 100vw);
  width: 100%;
  padding: 0 var(--screen-padding);
  margin: auto;

  @media screen and (width > 1024px) {
    --screen-padding: 0;
  }
`;
